import { useQuery } from "../AppLayout";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const navItems = (workspaceId) => [
  {
    name: "Deal",
    value: "SALE",
    href: `/workspaces/${workspaceId}/settings/data-fields?type=SALE&key=DataFields`,
  },
  {
    name: "Contact",
    value: "CONTACT",
    href: `/workspaces/${workspaceId}/settings/data-fields?type=CONTACT&key=DataFields`,
  },
  {
    name: "Account",
    value: "COMPANY",
    href: `/workspaces/${workspaceId}/settings/data-fields?type=COMPANY&key=DataFields`,
  },
  {
    name: "Product",
    value: "PRODUCT",
    href: `/workspaces/${workspaceId}/settings/data-fields?type=PRODUCT&key=DataFields`,
  },
];
const FieldNav = () => {
  const params = useQuery();
  const { projectId }: any = useParams();
  const { t } = useTranslation();
  const navItem = params.get("type") || "SALE";
  return (
    <header className="w-full flex justify-end pr-4">
      <nav className="flex overflow-x-auto py-2">
        <ul
          role="list"
          className="flex min-w-full flex-none gap-x-6 text-sm font-semibold leading-6"
        >
          {navItems(projectId).map((item) => (
            <li key={item.name}>
              <Link
                to={item.href}
                className={item.value == navItem ? "text-blue-600 border-b-2 border-blue-900" : ""}
              >
                {t(item.name)}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default FieldNav;
